import { useEffect, useRef } from "react";

import useAxiosPrivate from "@/api/hooks/useAxiosPrivate";
import Table from "@/components/Table/Table";
import useTutorialMode from "@/components/TutorialMode/hooks/useTutorialMode";
import useResponse from "@/shared/hooks/useResponse";
import { useCompaniesTableStore } from "@/stores/useTableStore";

import LayoutWrapper from "../../components/Layout/LayoutWrapper";
import CompaniesHeaderActions from "../../components/PageHeader/actions/pageHeaderActions/CompanieHeaderActions/CompaniesHeaderActions";
import EditCompanyDialog from "../../components/Table/actions/dialogs/Companies/EditCompanyDialog/EditCompanyDialog";
import useCompaniesInlineActions from "../../components/Table/actions/inlineActions/hooks/useCompaniesInlineActions";
import useTableInlineActions from "../../components/Table/hooks/useTableInlineActions";
import { USER_PERMISSIONS } from "../../roles/types/enums";
import { ROUTES, TABLE_NAMES, useMediaQueries } from "../../shared";

import { COMPANIES_TABLE_COLUMNS } from "./config";

const Companies = () => {
  const { getData } = useAxiosPrivate();
  const { handleResponse } = useResponse();
  const { inlineActions, rowData, isOpen, closeDialog } =
    useCompaniesInlineActions();

  const { isTutorialActive, handleTutorialInCompaniesTable } =
    useTutorialMode();

  const {
    isCheckable,
    setIsCheckable,
    resetInitialLoading,
    setParams,
    fetchData,
    setColumns,
    setInlineActions,
    closeDetails
  } = useCompaniesTableStore();

  const { toMd } = useMediaQueries();

  const { tableInlineActions } = useTableInlineActions(
    inlineActions,
    USER_PERMISSIONS.EditCompanies,
    undefined,
    undefined,
    true
  );

  const hasFetched = useRef(false);

  useEffect(() => {
    const columns = toMd
      ? COMPANIES_TABLE_COLUMNS.mobile
      : COMPANIES_TABLE_COLUMNS.desktop;

    setColumns(
      columns.map(col => ({
        ...col,
        isActive: Boolean(col.isDefaultActive)
      }))
    );
  }, [toMd]);

  useEffect(() => {
    if (!hasFetched.current) {
      resetInitialLoading();
      hasFetched.current = true;
      handlePageLoad();
    }

    setParams({
      pageNumber: "1"
    });
  }, []);

  const handlePageLoad = async () => {
    await fetchData(getData, handleResponse);
    isTutorialActive && handleTutorialInCompaniesTable(closeDetails);
    !isCheckable && setIsCheckable(true);

    setInlineActions(tableInlineActions);
  };

  return (
    <>
      <LayoutWrapper
        showDetailsSection
        tableName={TABLE_NAMES.Companies}
        route={ROUTES.Companies}
      >
        <CompaniesHeaderActions />
      </LayoutWrapper>
      <Table
        hasDetails
        hideFilters
        hasSearch={false}
        hasFooter={false}
        route={ROUTES.Companies}
      />

      {/* inline action dialog */}
      {rowData && (
        <EditCompanyDialog
          isOpen={isOpen}
          onClose={closeDialog}
          rowData={rowData}
        />
      )}
    </>
  );
};

export default Companies;
